import axios from "axios";
import { ApiError } from "../../shared/errors/ApiError";

export function normalizeApiError(error, fallbackMessage = "Erro ao buscar dados da API") {
  if (error instanceof ApiError) {
    return error;
  }

  if (axios.isAxiosError(error)) {
    const apiError = error.response?.data;

    if (apiError?.error && apiError?.message) {
      return new ApiError(apiError);
    }

    if (apiError?.message) {
      return new ApiError({
        error: "api_error",
        message: apiError.message,
        details: apiError,
      });
    }

    if (!error.response) {
      return new ApiError({
        error: "network_error",
        message: "Não foi possível conectar ao servidor.",
        details: {
          code: error.code,
          message: error.message,
        },
      });
    }
  }

  return new ApiError({
    error: "unknown_error",
    message: fallbackMessage,
  });
}
